import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_right",
  "use": "icon-i_right-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_right\"><title>icon_画板</title><path d=\"M13.21,8.3a1.11,1.11,0,0,1,.79.32l7.59,7.6a1.11,1.11,0,0,1,0,1.58L14,25.39a1.11,1.11,0,0,1-1.58-1.57L19.23,17,12.42,10.2a1.13,1.13,0,0,1,0-1.58A1.09,1.09,0,0,1,13.21,8.3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol